import classNames from 'classnames';
import { LoginButton } from '~/components/Auth';
import { T } from '~/components/I18n';
import defaultProfile from '~/components/Icon/default-profile.png';
import styles from '~/components/Status/Bar/ErrorFallback/StatusBarErrorFallback.module.scss';
import statusBarStyles from '~/components/Status/Bar/StatusBar.module.scss';
import profileStyles from '~/components/Status/Bar/StatusBarProfile.module.scss';

export type UnauthorizedStatusBarProps = {
  className?: string;
};

export const UnauthorizedStatusBar = ({ className }: UnauthorizedStatusBarProps) => (
  <div className={classNames(statusBarStyles.root, styles.root, className)}>
    <div className={statusBarStyles.header}>
      <img
        src={defaultProfile}
        className={profileStyles.image}
        width={50}
        height={50}
        alt="login required"
      />
      <div className={profileStyles.body}>
        <p className={styles.needLogin}>
          <T name="citizen_nonlogin_desc" />
        </p>
      </div>
    </div>
    <div className={statusBarStyles.aside}>
      <LoginButton className={statusBarStyles.button}>
        <T name="citizen_login_btn" />
      </LoginButton>
    </div>
  </div>
);
